import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'Sécurité garantie',
      description: 'Vos données sont protégées selon les normes RGPD'
    },
    {
      icon: 'Lock',
      title: 'Connexion sécurisée',
      description: 'Chiffrement SSL 256 bits pour toutes les transactions'
    },
    {
      icon: 'CheckCircle',
      title: 'Certifié professionnel',
      description: 'Entreprise certifiée Qualibat et RGE'
    },
    {
      icon: 'Clock',
      title: 'Support 24/7',
      description: 'Assistance disponible à tout moment'
    }
  ];

  const certifications = [
    { name: 'RGPD', icon: 'FileCheck' },
    { name: 'Qualibat', icon: 'Award' },
    { name: 'RGE', icon: 'Leaf' },
    { name: 'ISO 9001', icon: 'BadgeCheck' }
  ];

  return (
    <div className="space-y-8">
      <div className="bg-card rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="ShieldCheck" size={24} color="var(--color-primary)" />
          Pourquoi nous faire confiance ?
        </h3>
        
        <div className="space-y-4">
          {trustFeatures?.map((feature, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground mb-1">
                  {feature?.title}
                </h4>
                <p className="text-xs text-muted-foreground">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-lg shadow-md p-6">
        <h3 className="text-sm font-medium text-foreground mb-4">
          Certifications et conformité
        </h3>
        
        <div className="grid grid-cols-2 gap-3">
          {certifications?.map((cert, index) => (
            <div
              key={index}
              className="bg-muted rounded-lg p-3 flex items-center gap-2"
            >
              <Icon name={cert?.icon} size={16} color="var(--color-success)" />
              <span className="text-xs font-medium text-foreground">
                {cert?.name}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" />
          <div>
            <h4 className="text-sm font-medium text-foreground mb-1">
              Protection de vos données
            </h4>
            <p className="text-xs text-muted-foreground">
              Vos données et votre localisation ne sont partagées qu'avec votre accord explicite. Conformité totale RGPD.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;